export const httpToHttps = url => {
  if (!url) {
    return;
  }
  if (url.match("http:")) {
    return url.replace("http:", "https:");
  }
  return url;
};

export const getOptimizedAvatar = url => {
  if (!url) {
    return;
  }
  return httpToHttps(
    url.replace("upload", "upload/f_auto,q_160/w_100,c_scale")
  );
};

export const getOptimizedImage = url => {
  if (!url) {
    return;
  }
  return httpToHttps(url.replace("upload", "upload/so_0,f_auto,q_auto:low"));
};

export const getOptimizedOpportunityImage = url => {
  if (!url) {
    return;
  }
  return httpToHttps(
    url.replace("upload", "upload/so_0,f_auto,q_auto:low/w_400,c_scale")
  );
};
